import React from 'react';
import ImageIcon from '@material-ui/icons/Image';
import LinearProgress from '@material-ui/core/LinearProgress';

const AudioLoading = props => (
    <div>
      <ImageIcon style={{
        width: '100%',
        height: 200,
        color: '#eee'
      }}/>
      <LinearProgress />
    </div>
)

class Audio extends React.Component {
    state = {
        url: null,
        loading: true
    }

    async componentWillMount() {
        const {url} = this.props.src;
        this.setState({url, loading: false});
    }

    render() {
        const {url, loading} = this.state;
        if(loading) {
            return <AudioLoading />
        }
        return (
            <audio controls controlsList="nodownload" style={{width: '100%', minWidth: 300}}>
                <source src={url} />
            </audio>
        )
    }
}

export default Audio;
